import { Controller } from "@hotwired/stimulus"
import ConsultationForm from "@components/consultations/form.svelte"
import { mount, unmount } from "svelte"
import { isPreviewMode } from "@lib/utils"

const COMPONENT_KEY = "__svelteComponent"

// Connects to data-controller="consultation-form-svelte"
export default class extends Controller {
  connect() {
    if (isPreviewMode()) return
    
    this.teardown()
    if (this.beforeCache) document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.beforeCache = () => this.teardown()
    document.addEventListener("turbo:before-cache", this.beforeCache)

    const consultation = this.element.dataset.consultation ? JSON.parse(this.element.dataset.consultation) : null

    const clinicId = this.element.dataset.clinicId || consultation?.clinic_id
    
    const props = {
      immediateOpen: !!this.element.dataset.open,
      date: consultation?.date,
      clinicId,
      vetId: consultation?.vet_id,
      startTime: consultation?.start_time ? new Date(consultation.start_time) : null,
      endTime: consultation?.end_time ? new Date(consultation.end_time) : null,
      clientId: consultation?.client_id,
      animalIds: consultation?.animal_ids || [],
      calendar: !!this.element.dataset.calendar,
      allDay: !!this.element.dataset.allDay
    }
    const component = mount(ConsultationForm, {
      target: this.element,
      props
    })
    this.component = component
    this.element[COMPONENT_KEY] = component
  }

  disconnect() {
    if (this.beforeCache) {
      document.removeEventListener("turbo:before-cache", this.beforeCache)
      this.beforeCache = null
    }
    this.teardown()
  }
  
  teardown() {
    const existing = this.element[COMPONENT_KEY] || this.component
    if (existing) unmount(existing)
    this.element[COMPONENT_KEY] = null
    this.component = null
    this.element.innerHTML = ""
  }
}
